import React, { useState, useEffect } from 'react';

import AddOperator from '../../Components/AddOperator'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function AddRegionalManager(props) {

    const [ regionalManager, setRegionalManager ] = useState({
        cpf: '',
        name: '',
        dt_canc_exp: '',
        ident_dig: ''
    });
    const [ loadRegionalManager, setLoadRegionalManager ] = useState(false);

    const [ organOptions, setOrganOptions ] = useState([]);

    const [ unidadeOptions, setUnidadeOptions ] = useState([]);

    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(()=>{
        async function loadOrgans(){
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "" //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaOrgaoGestorRegional`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
    
                        var organList = [];
                        var obj = {};
    
                        data.forEach((organ) => {
                            obj = {
                                value: organ.CODIGO_ORGAO,
                                label: organ.NOME_ORGAO
                            }
    
                            organList.push(obj);
                        });
    
                        setOrganOptions(organList);
                    });
                } else {
                    console.log('Error request to /gestao/consultaorgaogestor');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        async function loadUnidade() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    codigo_orgao: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_orgao : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaUnidadesPorOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
    
                        var unidadesList = [];
                        var obj = {};

                        data.forEach((unidade) => {
                            obj = {
                                value: unidade.CODIGO_UNIDADE,
                                label: unidade.NOME_UNIDADE
                            }

                            unidadesList.push(obj);
                        });

                        setUnidadeOptions(unidadesList);
                    });
                } else {
                    console.log('Error request to /gestao/listaUnidadesPorOrgao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        if (!loadRegionalManager && props.location.state !== undefined) {
            setRegionalManager({
                cpf: props.location.state.cpf,
                name: props.location.state.name,
                dt_canc_exp: props.location.state.dt_canc_exp,
                ident_dig: props.location.state.ident_dig
            });

            loadOrgans();
            loadUnidade();
            setLoadRegionalManager(true);
        }
    }, [props.location.state, loadRegionalManager]);

    const [ loadingAdd, setLoadingAdd ] = useState(false);    

    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

     // ================================================================================

    const onSubmitRegionalManagerData = async (data) => {

        setLoadingAdd(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                cpf_gestor_regional: regionalManager.cpf,
                nome_gestor_regional: regionalManager.name,
                codigo_orgao: data.organ.value,
                codigo_unidade: data.unidade.value,
                data_cancelamento: regionalManager.dt_canc_exp
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/cadastraGestorRegional`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {
                    const regionalManager_added = {
                        from: "addRegionalManager",
                        id_usuario_orgao: data_request.objGestorRegional.id_usuario_orgao,
                        cpf: data_request.objGestorRegional.cpf_gestor_regional,
                        name: data_request.objGestorRegional.nome_gestor_regional,
                        organ: data.organ,
                        unidade: data.unidade,
                        dt_inc: data_request.objGestorRegional.data_inclusao,
                        dt_canc_exp: data_request.objGestorRegional.data_cancelamento,
                        unit: props.location.state?.unit,
                        userlist: props.location.state?.userlist,
                        returnTo: props.location.state?.returnTo
                    }
                    setLoadingAdd(false);
                    const redirectTo = (props.location.state?.returnTo === 'addunit')? '/adicionarUnidade' : ((props.location.state?.returnTo === 'editunit')? '/editarUnidade' : 'mostrarGestorRegional')
                    sessionStorage.setItem('successMsg', 'Gestor regional cadastrado com sucesso.');
                    props.history.push(redirectTo, regionalManager_added);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/cadastraGestorRegional BackendBalcao');
                    }

                    setLoadingAdd(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingAdd(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingAdd(false);
                console.log('Error request to /gestao/cadastraGestorRegional');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <AddOperator
                pageTitle='Cadastrar gestor regional'
                expirationDateHint='(Caso uma data de expiração seja definida, o usuário será automaticamente excluído e terá seu acesso revogado na data estipulada)'
                onSubmitData={onSubmitRegionalManagerData}
                loadOperator={loadRegionalManager}
                operator={regionalManager}
                setOperator={setRegionalManager}
                organOptions={organOptions}
                unidadeOptions={unidadeOptions}
                loadingAdd={loadingAdd}
                setLoadingAdd={setLoadingAdd}
                modalError ={modalError}
                setModalError={setModalError}
                messageError={messageError}
                buttonCancelRoute='/consultaGestorRegional'
                history={props.history}
                buttonConfirm={(props.location.state?.returnTo === 'addunit' || props.location.state?.returnTo === 'editunit')? 'Confirmar e Voltar p/ Unidade' : 'Confirmar'}
                buttonBackRouteToDataState={(props.location.state?.unit || props.location.state?.userlist)? {returnTo: props.location.state?.returnTo, unit: props.location.state?.unit, userlist: props.location.state?.userlist} : undefined}
            />
        </>
    );
}